module.exports = __webpack_public_path__ + "img/edwardjames.e800f1be.png";